import { defineStore } from 'pinia'

// quick and dirty bomb
const debugMode = false;

export const useSettings = defineStore('useSettings', {
  state: () => {
    return {
      isAuthenticated: debugMode,
      backendApi: process.env.VUE_APP_BACKEND,
      apiAuth: '?key=' + process.env.VUE_APP_TOKEN,
      userPid: null,
      userEmail: null,
      userName: null,
      userRole: null,
      userRoleId: null,
      userCompany: null,
      userDepartment: null,
      userDepartmentId: null,
      userPhone: null,
      userCustomerId: null,
      status: 0,
      updateExists: false,
      users: [],
      departments: [],
      roles: [],
      errors: [],
      stores: [],
      store: {
        sorting: {
          column: '',
          ascending: true
        },
        filters: {
          selected: {
            country: '',
            city: ''
          },
          searchString: '',
          countries: ['United States', 'Denmark', 'Germany', 'France', 'Netherlands', 'Sweden', 'Spain', 'United Kingdom'],
          cities: ['London', 'Copenhagen', 'Amsterdam', 'Berlin', 'Madrid', 'Stockholm', 'Paris', 'New York']
        },
        add: {
          name: '',
          address_line_1: '',
          address_line_2: '',
          city: '',
          state_province: '',
          postal_code: '',
          country: '',
          phone: '',
          website: '',
          email: '',
          type_id: '',
          status_id: '',
          status_p_id: '2',
          type_p_id: '1',
          lat: '',
          lon: '',
        },
      },
      editStore: {},
      editUser: {},
      storeStatus:[],
      storeStatusNew: [],
      storeTypes: [],
      pim: {
        products: []
      },
      products: [],
      blogPosts: [],
      topMenu: [],
      selectedPostId: '',
      collections: [],
      selectedCollectionId: '',
      collectionHandleData: {},
      digests: [],
      translations: {
        digests: {},
        properties: {
          en: {
            include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
          },
          de: {
            include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
          },
          es: {
            include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
          },
          sv: {
            include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
          },
          fr: {
            include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
          },
          nl: {
            include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
          },
          da: {
            include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
          },
          gb: {
            include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
          },
        },
        userLangs: {
          de: {
            visible: false,
            shopifyShort: 'de',
            shopifyLong: 'German'
          },
          es: {
            visible: false,
            shopifyShort: 'es',
            shopifyLong: 'Spanish'
          },
          sv: {
            visible: false,
            shopifyShort: 'sv',
            shopifyLong: 'Swedish'
          },
          fr: {
            visible: false,
            shopifyShort: 'fr',
            shopifyLong: 'French'
          },
          nl: {
            visible: false,
            shopifyShort: 'nl',
            shopifyLong: 'Dutch'
          },
          da: {
            visible: false,
            shopifyShort: 'da',
            shopifyLong: 'Danish'
          },
          gb: {
            visible: false,
            shopifyShort: 'gb',
            shopifyLong: 'British'
          },
          en: {
            visible: false,
            shopifyShort: 'en',
            shopifyLong: 'English'
          }
        },
        de: {},
        es: {},
        sv: {},
        fr: {},
        nl: {},
        da: {},
        gb: {},
        en: {}
      }
    }
  },
  actions: {
    async updateData(){
      this.getDepartments();
      this.getRoles();
    },
    async getStores() {
      this.stores = [];
      this.storeStatusNew = [];
      
      const res = await fetch(process.env.VUE_APP_BACKEND + "/stores" + this.apiAuth);
      const data = await res.json();

      if(this.store.sorting.column != ''){
        data.sort((a, b) => {
          if (a[this.store.sorting.column] < b[this.store.sorting.column]) return -1;
          if (a[this.store.sorting.column] > b[this.store.sorting.column]) return 1;
          return 0;
        });
      }
      else{
        // sort stores by country, state, city and name
        data.sort((a, b) => {
          if (a.country < b.country) return -1;
          if (a.country > b.country) return 1;
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          if (a.city < b.city) return -1;
          if (a.city > b.city) return 1;
          if (a.state_province < b.state_province) return -1;
          if (a.state_province > b.state_province) return 1;
          
          return a.name.localeCompare(b.name);
        });

      }

      // map the store that are new
      data.forEach(store => {
        if (store.status_p_id === 1) {
          this.storeStatusNew.push(store);
        }
      });

      this.stores = data;
    },
    async getStoreStatus() {
      this.storeStatus = [];

      const res = await fetch(process.env.VUE_APP_BACKEND + "/stores/status_ids" + this.apiAuth);
      const data = await res.json();

      this.storeStatus = data;
    },
    async getStoreTypes() {
      this.storeTypes = [];

      const res = await fetch(process.env.VUE_APP_BACKEND + "/stores/type_ids" + this.apiAuth);
      const data = await res.json();

      this.storeTypes = data;
    },
    async deleteStore(p_id) {
      return fetch(process.env.VUE_APP_BACKEND + "/stores/" + p_id + this.apiAuth, {
        method: 'DELETE'
      });
    },
    async updateGeolocation(target) {
      const store = target || this.editStore;

      const path = store.p_id
        ? "/stores/" + store.p_id + "/geocode"
        : "/stores/geocode";

      const res = await fetch(process.env.VUE_APP_BACKEND + path + this.apiAuth, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: store.name,
          address_line_1: store.address_line_1,
          address_line_2: store.address_line_2,
          city: store.city,
          state_province: store.state_province,
          postal_code: store.postal_code,
          country: store.country,
        })
      });

      if (!res.ok) {
        throw new Error("Geocoding failed: " + res.status);
      }

      const data = await res.json();

      store.lat = data.message.lat;
      store.lon = data.message.lng;
      store.businessStatus = data.businessStatus;

      if(data.businessStatus != "UNKNOWN") {
        store.status_p_id = 2;
      }
    },
    async getDepartments() {
      this.departments = [];

      const res = await fetch(process.env.VUE_APP_BACKEND + "/apps/departments" + this.apiAuth);
      const data = await res.json();

      this.departments = data;
    },
    async addDepartment(name) {
      await fetch(process.env.VUE_APP_BACKEND + "/apps/departments" + this.apiAuth, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name })
      });
      await this.getDepartments();
    },
    async updateDepartment(id, name) {
      await fetch(process.env.VUE_APP_BACKEND + "/apps/departments/" + id + this.apiAuth, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name })
      });
      await this.getDepartments();
    },
    async deleteDepartment(id) {
      await fetch(process.env.VUE_APP_BACKEND + "/apps/departments/" + id + this.apiAuth, {
        method: 'DELETE'
      });
      await this.getDepartments();
    },
    async getRoles() {
      this.roles = [];

      const res = await fetch(process.env.VUE_APP_BACKEND + "/apps/usergroups" + this.apiAuth);
      const data = await res.json();

      this.roles = data;
    },
    async addRole(name) {
      await fetch(process.env.VUE_APP_BACKEND + "/apps/usergroups" + this.apiAuth, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name })
      });
      await this.getRoles();
    },
    async updateRole(id, name) {
      await fetch(process.env.VUE_APP_BACKEND + "/apps/usergroups/" + id + this.apiAuth, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name })
      });
      await this.getRoles();
    },
    async deleteRole(id) {
      await fetch(process.env.VUE_APP_BACKEND + "/apps/usergroups/" + id + this.apiAuth, {
        method: 'DELETE'
      });
      await this.getRoles();
    },
    async marketTranslationChecker() {
      const res = await fetch(process.env.VUE_APP_BACKEND + "/apps/users" + this.apiAuth);
      const data = await res.json();

      data.forEach(x => {
        if(x.email === this.userEmail){
          this.translations.userLangs.de.visible = x.translations_de;
          this.translations.userLangs.da.visible = x.translations_da;
          this.translations.userLangs.en.visible = x.translations_en;
          this.translations.userLangs.es.visible = x.translations_es;
          this.translations.userLangs.fr.visible = x.translations_fr;
          this.translations.userLangs.nl.visible = x.translations_nl;
          this.translations.userLangs.sv.visible = x.translations_sv;
          this.translations.userLangs.gb.visible = x.translations_uk;
        }
      })
    },
    async userLogin(email,password) {
      const res = await fetch(process.env.VUE_APP_BACKEND + "/apps/users" + this.apiAuth);
      const data = await res.json();

      data.forEach(x => {
        if(x.email === email && x.password === password){
          this.isAuthenticated = true;
          this.userPid = x.p_id;
          this.userEmail = x.email;
          this.userName = x.username;
          this.userRole = x.user_group_name;
          this.userRoleId = x.user_group_id;
          this.userDepartment = x.department_name;
          this.userDepartmentId = x.user_department_id;
          this.userCustomerId = x.customer_p_id;

          // prepare the app
          this.marketTranslationChecker();
          this.getDepartments();
          this.getRoles();
          this.getStores();

          this.setSession(1);
        }
      })

      if(!this.isAuthenticated){
        this.errors.push("Login failed");
      }
    },
    async updateOnRouteChange() {
      console.log('Route has changed!')
    },
    async userLogout() {
      this.isAuthenticated = false;
      this.setSession(0);

    },
    async setSession(value) {
      this.status = value;      
    },
    async getUsers() {
      this.users = [];

      const res = await fetch(process.env.VUE_APP_BACKEND + "/apps/users" + this.apiAuth);
      const data = await res.json();
      
      this.users = data;
    },
    async saveUser(data) {
      data.customer_p_id = this.userCustomerId;

      await fetch(process.env.VUE_APP_BACKEND + "/apps/users" + this.apiAuth, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      await this.getUsers();
    },
    async changePassword(currentPassword, newPassword) {
      const res = await fetch(process.env.VUE_APP_BACKEND + "/apps/users/" + this.userPid + "/password" + this.apiAuth, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          currentPassword: currentPassword,
          newPassword: newPassword
        })
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || 'Password change failed');
      }

      return res.json();
    },
    async deleteUser(p_id) {
      return fetch(process.env.VUE_APP_BACKEND + "/apps/users/" + p_id + this.apiAuth, {
        method: 'DELETE'
      });
    },
    async saveStore(data) {
      return fetch(process.env.VUE_APP_BACKEND + "/stores/" + data.p_id + this.apiAuth, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
    },
    async addStore() {
      return fetch(process.env.VUE_APP_BACKEND + "/stores" + this.apiAuth, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.store.add)
      });
    },
    async getProductsPim() {
      const res = await fetch(process.env.VUE_APP_BACKEND + "/shopify/products" + this.apiAuth);
      const data = await res.json();

      this.pim.products = data.data;
    },
    async updateProductPim(data) {
      return fetch(process.env.VUE_APP_BACKEND + "/shopify/update/metafield" + this.apiAuth, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
    },
    async getCollections(){
      const res = await fetch(process.env.VUE_APP_BACKEND + "/shopify/translations/collection" + this.apiAuth);
      const data = await res.json();

      this.collections = data.data;

      return this.collections;
    },
    async getCollectionByHandle(contentType, idNumber) {
      const res = await fetch(`${process.env.VUE_APP_BACKEND}/shopify/seo/${contentType}/${idNumber}${this.apiAuth}`);
      const data = await res.json();
      return data;
    },
    async getProducts(){
      const res = await fetch(process.env.VUE_APP_BACKEND + "/shopify/translations/products" + this.apiAuth);
      const data = await res.json();

      this.products = data.data;

      return this.products;
    },
    async getBlogPosts(){
      const res = await fetch(process.env.VUE_APP_BACKEND + "/shopify/translations/blogs" + this.apiAuth);
      const data = await res.json();

      this.blogPosts = data.data;

      return this.blogPosts;
    },
    async copyLocale(locale) {
      for (const key in this.translations['en']) {
        if(!this.translations[locale][key] || this.translations[locale][key] == '') {
          this.translations[locale][key] = this.translations['en'][key];
        }
      }
    },
    async mergeDatabaseTranslations(gid, idNumber, contentType) {
      const langCodes = ['en', 'de', 'es', 'sv', 'fr', 'nl', 'da', 'gb'];
      const translationsEntries = {};
      const defaultProperties = {
        en: {
          include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
        },
        de: {
          include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
        },
        es: {
          include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
        },
        sv: {
          include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
        },
        fr: {
          include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
        },
        nl: {
          include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
        },
        da: {
          include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
        },
        gb: {
          include: [{key: 'meta_title', value: true},{key: 'meta_description', value: true}],
        },
      };

      // insert a new row with the GID if none exists yet
      await fetch(`${process.env.VUE_APP_BACKEND}/apps/translations/new${this.apiAuth}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ gid: gid, user: this.userEmail, properties: defaultProperties })
      });

      // move on and fetch both resources in parallel
      const [resShopify, resDatabase] = await Promise.all([
        fetch(`${process.env.VUE_APP_BACKEND}/shopify/seo/${contentType}/${idNumber}${this.apiAuth}`),
        fetch(`${process.env.VUE_APP_BACKEND}/apps/translations${this.apiAuth}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ gid: gid, user: this.userEmail })
        })
      ]);

      const dataShopify = await resShopify.json() || [];
      const dataDatabase = await resDatabase.json() || [];

      const parseLang = (lang) => {
        try {
          const raw = dataDatabase[lang];
          if (!raw) return [];
          const fixed = raw.replace(/'/g, '"');
          return JSON.parse(fixed);
        } catch (e) {
          console.warn(`Could not parse ${lang}:`, e);
          return [];
        }
      };

      const mergeLang = (lang, fallbackLang = lang) => {
        const dbData = parseLang(lang) || [];
        const shopifyData = dataShopify.data.translatableResource[fallbackLang] || [];

        if (dbData.length === 0) {
          console.warn(`No Shopify data found for ${lang}`);
          return shopifyData;
        }

        return dbData.map(item => {
          const match = shopifyData.find(d => d.key === item.key);
          return { ...item, translation: match?.value || null, digest: item.digest || null };
        });
      };

      langCodes.forEach(lang => {
        const fallback = lang === 'gb' ? 'en' : lang;
        translationsEntries[lang] = mergeLang(lang, fallback).reduce((acc, t) => {
          acc[t.key] = t.value || '';
          return acc;
        }, {});
      });

      // locate the content digests from Shopify data en only and rewrite to this format {key: 'title', value: 'abc123'}
      const digests = (dataShopify.data.translatableResource.en || []).reduce((acc, item) => {
        if (item.digest) acc[item.key] = item.digest;
        return acc;
      }, {});

      // populate properties if it exists from the database
      if (dataDatabase.properties) {
        // convert properties from string to object
        this.translations.properties = JSON.parse(dataDatabase.properties);
      } else {
        this.translations.properties = defaultProperties;
      }
      
      // rewrite the digests to match the expected format [{key: 'title', value: 'abc123'}, ...]
      this.translations.digests = Object.entries(digests).map(([key, value]) => ({ key, value }));

      this.collectionHandleData = dataShopify.data.translatableResource;
      this.selectedCollectionId = dataShopify.data.translatableResource.resourceId;

      this.translations.en = translationsEntries.en;
      this.translations.de = translationsEntries.de;
      this.translations.es = translationsEntries.es;
      this.translations.sv = translationsEntries.sv;
      this.translations.fr = translationsEntries.fr;
      this.translations.nl = translationsEntries.nl;
      this.translations.da = translationsEntries.da;
      this.translations.gb = translationsEntries.gb;
    },
    async getTranslations(input) {
      const res = await fetch(process.env.VUE_APP_BACKEND + "/translate" + this.apiAuth, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(input)
      });
      
      const data = await res.json();
      return data;
    },
    async saveTranslations(input) {
      console.log('Saving translations:', input);

      return fetch(process.env.VUE_APP_BACKEND + "/shopify/seo/update/translation" + this.apiAuth, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(input)
      });
    },
    async postToDatabase() {
      // rewrite this.translations to match the expected format [{key: 'title', value: 'My Title'}, ...]
      const translationsDb = Object.entries(this.translations).reduce((acc, [lang, values]) => {
        acc[lang] = Object.entries(values).map(([key, value]) => ({ key, value }));
        return acc;
      }, {});

      const payload = {
        user: this.userEmail,
        gid: this.selectedCollectionId,
        en: translationsDb.en,
        da: translationsDb.da,
        de: translationsDb.de,
        es: translationsDb.es,
        fr: translationsDb.fr,
        nl: translationsDb.nl,
        sv: translationsDb.sv,
        gb: translationsDb.gb,
        properties: this.translations.properties,
      };

      try {
        const response = await fetch(process.env.VUE_APP_BACKEND + "/apps/translations" + this.apiAuth, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

      const data = await response.json();
      return data;

      } catch (error) {
        console.error('Error posting to database:', error);
      }
    }

  },
  persist: true,
})